import React from 'react';
import {
  LayoutDashboard,
  Menu,
  X,
  User,
  Bell,
  Package,
  Truck,
  MapPin,
  Percent,
  Calendar,
  Clock,
  History,
  DollarSign,
  CreditCard,
  FileText,
  Clipboard,
  Plus,
  PlusCircle,
  Trash2,
  Pencil,
  Save,
  Download,
  Send,
  Eye,
  EyeOff,
  Search,
  TrendingUp,
  TrendingDown,
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Info,
  Building2,
  Ship,
  Heart,
  Lock,
  Mail,
  Shield,
  ShieldCheck,
  Umbrella,
  Star,
  Tag,
  Users,
  Container,
  PlayCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Settings,
  Key,
  Image,
  LayoutGrid,
  ShoppingCart,
  UserPlus,
  HelpCircle,
  Upload,
  Globe,
  Zap,
  Inbox,
  Minus,
  MessageCircle,
  Phone,
  LucideIcon,
} from 'lucide-react';
import { IconWrapper } from './styles';
import { IconProps, IconName } from './types';

const iconMap: Record<IconName, LucideIcon> = {
  // Navigation & Layout
  LayoutDashboard,
  Menu,
  X,
  // User & Contact
  User,
  Bell,
  Inbox,
  Minus,
  MessageCircle,
  Phone,
  // Package & Shipping
  Package,
  Truck,
  MapPin,
  Percent,
  Container,
  // Calendar & Time
  Calendar,
  Clock,
  History,
  // Financial & Payment
  DollarSign,
  CreditCard,
  // Documents
  FileText,
  Clipboard,
  // Actions
  Plus,
  PlusCircle,
  Trash2,
  Pencil,
  Save,
  Download,
  Send,
  Eye,
  EyeOff,
  Search,
  // Status & Alerts
  TrendingUp,
  TrendingDown,
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Info,
  // Building & Location
  Building2,
  Ship,
  // Others
  Heart,
  Lock,
  Mail,
  Shield,
  ShieldCheck,
  Umbrella,
  Star,
  Tag,
  Users,
  // Media & Navigation
  PlayCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Settings,
  Key,
  Image,
  LayoutGrid,
  ShoppingCart,
  UserPlus,
  HelpCircle,
  Upload,
  Globe,
  Zap,
};

export const Icon: React.FC<IconProps> = ({ name, size = 24, color, className, ...props }) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconWrapper className={className}>
      <IconComponent size={size} color={color} {...props} />
    </IconWrapper>
  );
};

export type { IconProps, IconName } from './types';
